export default class StandardApiError extends Error {
  public data: unknown;
  public response: Response;
  public validationErrors: Record<string, string>;
  public requestErrors: string[];

  constructor(
      data: unknown,
      response: Response,
      validationErrors: Record<string, string>,
      requestErrors: string[],
  ) {
    super();
    this.data = data;
    this.response = response;
    this.validationErrors = validationErrors;
    this.requestErrors = requestErrors;
  }

  public toString() {
    return `StandardApiError ${this.message} ${this.response}`;
  }
}
